
import { login, loginOut } from '@/api/interface/user'
const app = {
  state: {
    userInfo: null,
    isMobile: false,
    timeDiff: 0,
    uploadParams: null,
    device: null,
    cityName: null, // 所在城市
    longitude: null, // 用户所在纬度
    latitude: null, // 用户所在经度
    publishStatus: 0,
    shareTitle: {},
    shareList: {
      indexM: '2021-2023年度·陕西省 中国民间文化艺术之乡 ',
      indexF: '促进文旅融合，助力乡村振兴。',
      newsM: '中国民间文化艺术之乡【TA说篇】',
      newsF: '民间艺术点亮乡村·听世界声音',
      newsD: '中国民间文化艺术之乡【TA说篇】展示',
      dialectM: '中国民间文化艺术之乡【乡话篇】',
      dialectF: '民间艺术点亮乡村·看乡村魅力',
      dialectD:'中国民间文化艺术之乡【乡话篇】展示',
      characterM: '中国民间文化艺术之乡【人物篇】',
      characterF: '民间艺术点亮乡村·听人物故事', 
      characterD:'中国民间文化艺术之乡【人物篇】展示',
      skillM: '中国民间文化艺术之乡【技艺篇】',
      skillF: '民间艺术点亮乡村·赏工匠技艺',
      skillD:'中国民间文化艺术之乡【技艺篇】展示',
      MoocM: '中国民间文化艺术之乡【慕课篇】',
      MoocF: '民间艺术点亮乡村·学艺术传承',
      MoocD:'中国民间文化艺术之乡【慕课篇】展示',

      culturalM:'中国民间文化艺术之乡【相关文献】',
      culturalF:'匠心独运，瑰宝传承。',
      culturalD:'中国民间文化艺术之乡【相关文献】展示',
      atlasM: '中国民间文化艺术之乡【图集】',
      atlasF:'古韵新风，共筑华章。',
      atlasD: '中国民间文化艺术之乡【图集】展示',


      sjcwDetail: '2024年四季“村晚”示范展示活动精彩直播',
      dnkcwDetail: '2024年四季“村晚”示范展示活动·带你看村晚',
      zajmDetail: '2024年四季“村晚”示范展示活动·我最爱的村晚节目',
     
      wlrlM: '2024年四季“村晚”示范展示活动活动日历',
      wlrlF: '锁定活动日程，掌握最新动态',
      xcwhlistF: '',
      resultM: '',
      resultF: '',
      myEyesM:'2024年四季“村晚”示范展示活动·我眼中的村晚',
      myEyesF: '我眼中的村晚',
      imgUrl: require('../../assets/img/shareicon.png'),
      videoUrl: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/宣传片/3-民间艺术宣传片.mp4',
      coverUrl:'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/宣传片/3-艺术之乡.png'

    },
    operate: {
      operateCode:'a9762a2e-aeb5-4f16-a548-451c5155f661', //   2024 民间文化艺术
      news: '5a87513e-f24f-46cf-a390-000450cb641f-news',//	大地欢歌-四季村晚	大地欢歌-四季村晚--图文
      likeHistory: '5a87513e-f24f-46cf-a390-000450cb641f-like-history',//	大地欢歌-四季村晚	大地欢歌-四季村晚-地方风采
      like23: '5a87513e-f24f-46cf-a390-000450cb641f-like-2023',//	大地欢歌-四季村晚	大地欢歌-四季村晚2023节目评选
      tidbits: '5a87513e-f24f-46cf-a390-000450cb641f-tidbits',//	大地欢歌-四季村晚	大地欢歌-四季村晚花絮
      star: '5a87513e-f24f-46cf-a390-000450cb641f-star',//乡村网红
      eye:'5a87513e-f24f-46cf-a390-000450cb641f-eye',//2024-大地欢歌-四季村晚	大地欢歌-四季村晚-我眼中的村晚
	    point:'5a87513e-f24f-46cf-a390-000450cb641f-point',//2024-大地欢歌-四季村晚	大地欢歌-四季村晚-示范点风采
	
    },
    infoList: {
      sjcw: '为传承中华优秀传统文化，弘扬社会主义先进文化，丰富广大人民群众精神文化生活，文化和旅游部于2021年组织开展了2021-2023年度“中国民间文化艺术之乡”评审命名工作。根据评审命名工作方案，经评审和公示，决定命名183个县（市、区）、乡镇（街道）为2021-2023年度“中国民间文化艺术之乡”。其中，陕西省榆林市榆阳区、延安市安塞区、渭南市华州区、榆林市绥德县四十里铺镇、铜川市印台区陈炉镇、渭南市富平县宫里镇、汉中市汉台区龙江街道等7地入选。',
      zajm1: '陕西省文化馆“四季村晚”系列活动之“我最爱的村晚节目”，精选一批陕西省近年来农民群众自编自导自演的“村晚”精彩节目，展开线上展示及点赞。',
      zajm2: '同时，针对2024年度短视频征集，开展线上网络点赞，最终推选出10个优秀节目并发布榜单，在主流媒体进行宣推，并收录至全民艺术普及资源总库。快来一键参与，为你最喜爱的“村晚”节目助力吧！',
      zajm3: '1、点赞时段：待2024年短视频征集后集中发起；',
      zajm4: '2、每个用户可为多个短视频作品点赞；',
      zajm5: '3、每个用户每天对同一作品可点赞5次。',
      dnkcw1: '家门口的大联欢！',
      dnkcw2: '带你探寻“村晚”节目背后的故事，浓浓家乡味，美丽新乡村。',
      dnkcw3: '多维呈现村晚故事，感受村晚现场氛围。',
      wlzq1: '将村里的故事讲给你听。',
      wlzq2: '倾听文旅小故事，领略文旅好风光。',
      wlzq3: '融合乡土文化、乡村旅游，呈现农民精神新风貌、乡村振兴新气象。', 
      wyzdcw:'群众故事群众说。记录大家眼中的村晚精彩。'
    },
    classNameList: [
      // 全部、宣传片、乡话、人物、技艺、慕课 
      // {title:'全部',value:null},
      {title:'宣传片',value:'film'},
      {title:'乡话',value:'dialect'},
      {title:'人物',value:'character'},
      {title:'技艺',value:'skill'},
      {title:'慕课',value:'Mooc'},
    ],
    subClassNameList: [ 
      {title:'全部',value:null},
      {title:'宣传片',value:'film'},
      {title:'图集',value:'atlas'},
      {title:'乡话',value:'dialect'},
      {title:'人物',value:'character'},
      {title:'技艺',value:'skill'},
      {title:'慕课',value:'Mooc'},
    ],
    ewmList: [
      { title: '微信公众号', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/wx.png'), ewm: require('../../assets/img/wx.jpg') },
      { title: '视频号', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/sph.png'), ewm: require('../../assets/img/sph.jpg')  },
      { title: '官方微博', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/wb.png'), ewm: require('../../assets/img/wb.png') },
      { title: 'bilibili 哔哩哔哩', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/B.png'), ewm: require('../../assets/img/bz.png') },
      { title: '官方抖音', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/dy.png'), ewm: require('../../assets/img/dy.jpg') },
      { title: '快手', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/ks.png'), ewm: null },
    ],
    youList: [
      { cover: require('../../assets/img/sjcw/logo1.png'), path: 'http://whhlyt.shaanxi.gov.cn/' },
      { cover: require('../../assets/img/sjcw/logo2.png'), path: 'http://sxswhg.org.cn/' },
      { cover: require('../../assets/img/sjcw/logo3.png'), path: 'http://www.sxggwhy.com/' },
    ],
 

 
oneSubset:{}
  },

  mutations: {
    SET_ONESUBSET: (state, oneSubset) => {
      state.oneSubset = oneSubset
    },
    SET_FOURLIST: (state, fourList) => {
      state.fourList = fourList
    },
    SET_PUBLISHOVER: (state, publishStatus) => {
      state.publishStatus = publishStatus
    },
    SET_SHARELIST: (state, shareList) => {
      state.shareList = shareList
    },
    SET_SHARETITLE: (state, shareTitle) => {
      state.shareTitle = shareTitle
    },
    SET_OPERATECODE: (state, operateCode) => {
      state.operateCode = operateCode
    },
    SET_DEVICE: (state, device) => {
      state.device = device
    },
    SET_POSITION: (state, position) => {
      state.position.latitude = position.latitude
      state.position.longitude = position.longitude
    },
    SET_CITY: (state, cityName) => {
      state.cityName = cityName
    },
    SET_LONGITUDE: (state, longitude) => {
      state.longitude = longitude
    },
    SET_LATITUDE: (state, latitude) => {
      state.latitude = latitude
    },
    SET_MAPDATA: (state, obj) => {
      state.cityName = obj.city
      state.longitude = obj.bounds.northeast.lng
      state.latitude = obj.bounds.northeast.lat
      state.latitude = obj.bounds.northeast.lat
    },
    SET_UPLOADPARAMS: (state, uploadParams) => {
      state.uploadParams = uploadParams
    },
    SET_ISMOBILE: (state, isMobile) => {
      state.isMobile = isMobile
    },
    SET_USERINFO: (state, userinfo) => {
      state.userInfo = userinfo
    },
    SET_USERINFOLOGIN: (state, userinfologin) => {
      state.userinfologin = userinfologin
    },
    SET_SYSTIME: (state, timeDiff) => {
      state.timeDiff = timeDiff
    }
  },
  actions: {
    // 用户登录
    login({ commit }, userInfo) {
      const { userCode, password } = userInfo
      return new Promise((resolve, reject) => {
        login({ userCode: userCode.trim(), password: password }).then(response => {
          const { data } = response
          commit('SET_USERINFOLOGIN', response.data.data.list[0].user)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 用户登出
    loginOut({ commit }) {
      return new Promise((resolve, reject) => {
        loginOut().then(res => {
          commit('SET_USERINFOLOGIN', null)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js